import {
  getDetailsTabRoutes,
  getSelectableResult
} from "../../../utility/route";
import { childOfOrEqual } from "../../../router/functions";

export const distributionAccountListLDTRoutes = getDetailsTabRoutes(
  "accounts",
  "account_id"
);
export const distributionOrderListLDTRoutes = getDetailsTabRoutes(
  "orders",
  "order_id"
);
export const distributionSupplierListLDTRoutes = getDetailsTabRoutes(
  "suppliers",
  "supplier_id"
);

export const distributionStatementListLDTRoutes = getDetailsTabRoutes(
  "statement_list",
  "statement_id"
);

export const distributionSupplierOrderListLDTRoutes = getDetailsTabRoutes(
  "supplier_order",
  "supplier_order_id"
);

export const distributionShopListLDTRoutes = getDetailsTabRoutes(
  "shops",
  "shop_id"
);

export const distributionShop_groupListLDTRoutes = getDetailsTabRoutes(
  "shop_groups",
  "shop_group_id"
);
export const distributionReportsLDTRoutes = getDetailsTabRoutes(
  "reports",
  "report_id"
);
export const distributionReleaseReportsLDTRoutes = getDetailsTabRoutes(
  "release_reports",
  "release_id"
);
export const getDistributionReportDetailsSelectable = getSelectableResult(
  distributionReportsLDTRoutes
);
export const getDistributionReleaseReportDetailsSelectable = getSelectableResult(
  distributionReleaseReportsLDTRoutes
);
export const getDistributionAccountDetailsSelectable = getSelectableResult(
  distributionAccountListLDTRoutes
);
export const getDistributionOrderDetailsSelectable = getSelectableResult(
  distributionOrderListLDTRoutes
);
export const getSupplierDetailsSelectable = getSelectableResult(
  distributionSupplierListLDTRoutes
);

export const getDistributionSupplierOrderDetailsSelectable = getSelectableResult(
  distributionSupplierOrderListLDTRoutes
);

export const getDistributionStatementDetailsSelectable = getSelectableResult(
  distributionStatementListLDTRoutes
);

export const getDistributionShopDetailsSelectable = getSelectableResult(
  distributionShopListLDTRoutes
);

export const getDistributionShop_groupDetailsSelectable = getSelectableResult(
  distributionShop_groupListLDTRoutes
);

export const moduleRoutes = [
  distributionAccountListLDTRoutes,
  distributionOrderListLDTRoutes,
  distributionSupplierListLDTRoutes,
  distributionSupplierOrderListLDTRoutes,
  distributionStatementListLDTRoutes,
  distributionShopListLDTRoutes,
  distributionShop_groupListLDTRoutes,
  distributionReportsLDTRoutes,
  distributionReleaseReportsLDTRoutes
  
];

const detailsRoutes = moduleRoutes.map(m => m.names.details);

export const childOfOrEqualDetails = route => {
  return detailsRoutes.map(r => childOfOrEqual(r)).some(f => f(route.name));
};
